<footer class="footer d-flex flex-column align-items-center white-link min-h-print-0">
    <div class="container-fluid px-4 px-lg-0">
        <div class="row items justify-content-center gx-0">
            <div class="col-12 col-lg-auto mb-5 mb-lg-0 pe-lg-5 me-lg-4">
                <div class="logo d-flex flex-nowrap align-items-center text-white mb-3">
                    <span class="fs-1 fw-500 m-0 p-0 me-2 lh-1">GARD</span>
                    <span class="fs-7 m-0 p-0">Genetic and Rare Diseases <br />Information Center</span>
                </div>

                <div class="text-white">
                    <p class="m-0 mb-1">PO Box 8126,</p>
                    <p class="m-0">Gaithersburg, MD 20898-8126</p>
                </div>
            </div>

            <div class="col-6 col-lg-auto border-start border-white ps-3 ps-lg-5 pe-3 pe-lg-5 me-lg-3 d-print-none">
                <nav aria-label="Footer primary links">
                    <ul class="list-unstyled m-0">
                        <li class="mb-3"><a [routerLink]="['/' + paths.diseases]" [innerText]="labels.diseases"></a></li>
                        <li class="mb-3"><a href="https://resources.rarediseases.info.nih.gov/Resources/s/" [innerText]="labels.resources"></a></li>
                        <li class="mb-3"><a [routerLink]="'/' + paths.about" [innerText]="labels.about"></a></li>
                        <li><a [routerLink]="'/' + paths.contactUs" [innerText]="labels.contact"></a></li>
                    </ul>
                </nav>
            </div>

            <div class="col-6 col-lg-auto border-start border-white ps-3 ps-lg-5 d-print-none">
                <nav aria-label="Footer policy links">
                    <ul class="list-unstyled m-0">
                        <li class="mb-3">
                            <a [routerLink]="'/' + paths.privacyPolicy" [innerText]="labels.privacyPolicy"></a>
                        </li>
                        <li class="mb-3">
                            <a [routerLink]="'/' + paths.disclaimer" [innerText]="labels.disclaimer"></a>
                        </li>
                        <li class="mb-3">
                            <a [routerLink]="'/' + paths.accessibility" [innerText]="labels.accessibility"></a>
                        </li>
                        <li class="mb-3">
                            <a [routerLink]="'/' + paths.foia" [innerText]="labels.foia"></a>
                        </li>
                        <li>
                            <a link target="_blank" rel="noopener" [attr.href]="footerLinks.oig">{{ labels.oig }}</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>

    <div class="bottom py-lg-4 w-100 px-4 px-lg-0 fs-8 fs-md-6 d-print-none">
        <ul class="d-flex flex-column flex-lg-row list-unstyled m-0 justify-content-center mb-lg-2">
            <li class="fw-bold pe-lg-4 mb-3 mb-lg-2">
                <a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" target="_blank" rel="noopener" class="text-white">HHS Vulnerability Disclosure</a>
            </li>
        </ul>
        <ul class="d-flex flex-column flex-lg-row list-unstyled m-0 justify-content-center mb-lg-2">
            <li class="fw-bold pe-lg-4 mb-3 mb-lg-2">
                <a href="https://www.hhs.gov/" target="_blank" rel="noopener" class="text-white">U.S. Department of Health & Human Services</a>
            </li>
            <li class="fw-bold ps-lg-4 pe-lg-4 mb-3 mb-lg-2">
                <a href="https://www.nih.gov/" target="_blank" rel="noopener" class="text-white">National Institutes of Health</a>
            </li>
            <li class="fw-bold ps-lg-4 mb-3 mb-lg-2">
                <a href="https://ncats.nih.gov/" target="_blank" rel="noopener" class="text-white">National Center for Advancing Translation Sciences</a>
            </li>
        </ul>
        <p class="text-lg-center text-white m-0" [innerText]="labels.footerSlogan"></p>
    </div>
</footer>
